import { render, staticRenderFns } from "./home-2.vue?vue&type=template&id=895f1eba&"
import script from "./home-2.vue?vue&type=script&lang=js&"
export * from "./home-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports